module.exports = __webpack_public_path__ + "img/dangjianBg2.a03b2cea.png";